import { ActionMenu } from '@primer/react';
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FUNCTION_TYPE } from '../../utils/constants.js';
import OverlayArrowIcon from '../../icons/overlayArrowIcon.js';
import useScreenSizeChange from '../../customHooks/useScreenSizeChange.js';
import LTTooltip from '../LTTooltip/index.js';
import './index.css.js';
import { isEnterOrSpacePressed } from '../../utils/functions.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var LTInSessionSidebar = function LTInSessionSidebar(_ref) {
  var _menuItems$find2;
  var _ref$collapsed = _ref.collapsed,
    collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
    _ref$currentActiveMen = _ref.currentActiveMenuItemIndex,
    currentActiveMenuItemIndex = _ref$currentActiveMen === void 0 ? -1 : _ref$currentActiveMen,
    _ref$disablePointerCl = _ref.disablePointerClassName,
    disablePointerClassName = _ref$disablePointerCl === void 0 ? "" : _ref$disablePointerCl,
    _ref$extraMenuItemCla = _ref.extraMenuItemClassName,
    extraMenuItemClassName = _ref$extraMenuItemCla === void 0 ? "" : _ref$extraMenuItemCla,
    FalconFreemiumComponent = _ref.FalconFreemiumComponent,
    handleMouseMove = _ref.handleMouseMove,
    handleMouseMoveFreemium = _ref.handleMouseMoveFreemium,
    customRefObject = _ref.customRefObject,
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? "menu" : _ref$role,
    _ref$showFreemiumComp = _ref.showFreemiumComponentFlag,
    showFreemiumComponentFlag = _ref$showFreemiumComp === void 0 ? false : _ref$showFreemiumComp,
    showModal = _ref.showModal,
    setShowModal = _ref.setShowModal,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? "90" : _ref$tabIndex;
  var _listRefs = useRef({});
  var listRefs = customRefObject || _listRefs;
  var selectedIndex = useRef(-1);
  var tooltipRef = useRef(null);
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    openId = _useState2[0],
    setOpenId = _useState2[1];
  var _useState3 = useState(LTInSessionSidebar.constant.DEFAULT_MENU_ITEM_HEIGHT),
    _useState4 = _slicedToArray(_useState3, 2),
    menuItemHeight = _useState4[0],
    setMenuItemHeight = _useState4[1];
  var screenSize = useScreenSizeChange();
  useEffect(function () {
    if (screenSize < 600) {
      setMenuItemHeight(LTInSessionSidebar.constant.SMALL_SCREEN_MENU_ITEM_HEIGHT);
    } else {
      setMenuItemHeight(LTInSessionSidebar.constant.DEFAULT_MENU_ITEM_HEIGHT);
    }
  }, [screenSize]);
  useEffect(function () {
    if (showModal) {
      // close the overlay if the modal is opened
      setOpenId("");
    }
    return function () {
      //focus on the anchor element when the modal is closed
      if (showModal) {
        var _listRefs$current, _anchorElementParent$;
        // called when showModal state is to change from "someValue -> null"
        var anchorElementParent = (_listRefs$current = listRefs.current) === null || _listRefs$current === void 0 ? void 0 : _listRefs$current[showModal];
        anchorElementParent === null || anchorElementParent === void 0 || (_anchorElementParent$ = anchorElementParent.children) === null || _anchorElementParent$ === void 0 || (_anchorElementParent$ = _anchorElementParent$[0]) === null || _anchorElementParent$ === void 0 ? void 0 : _anchorElementParent$.focus();
      }
    };
  }, [showModal]);
  var getOverlayPosition = function getOverlayPosition(index, id) {
    var _menuItems$find, _listRefs$current$id;
    var elementOverlayHeight = menuItems === null || menuItems === void 0 || (_menuItems$find = menuItems.find(function (ele) {
      return ele.id === id;
    })) === null || _menuItems$find === void 0 ? void 0 : _menuItems$find.overlayHeight;
    var itemRefFromBottom = screenSize - ((_listRefs$current$id = listRefs.current[id]) === null || _listRefs$current$id === void 0 || (_listRefs$current$id = _listRefs$current$id.getBoundingClientRect()) === null || _listRefs$current$id === void 0 ? void 0 : _listRefs$current$id.bottom);
    if (itemRefFromBottom - elementOverlayHeight > 0) return menuItemHeight * index + 40;
    return Math.max(screenSize - elementOverlayHeight - 20, 0);
  };
  var tooltipCommonStyle = {
    position: "fixed",
    padding: "8.25px 5.5px",
    borderRadius: "6px"
  };
  var notShowTooltipHandler = function notShowTooltipHandler(notShowExpandTooltip, key) {
    return notShowExpandTooltip && showFreemiumComponentFlag && currentActiveMenuItemIndex == key;
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "lt-ch-left-nav-new",
    "class": "Left_Nav_new ".concat(collapsed ? "collapsed" : "")
  }, /*#__PURE__*/React.createElement("div", {
    "class": "header__aside__menu_new ".concat(collapsed ? "collapsed" : ""),
    id: "left_sidebar_header_new",
    role: "navigation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "aside__menu__item_new aside__menu__item_new__main__menu_new ltch-aside__menu__item_new text-ellipsis".concat(" ", extraMenuItemClassName),
    role: role
  }, menuItems.filter(function (_ref2) {
    var notRenderCondition = _ref2.notRenderCondition;
    return notRenderCondition !== false;
  }).map(function (_ref3, index) {
    var _LTInSessionSidebar$c;
    var ariaLabelDisable = _ref3.ariaLabelDisable,
      forceOpenOverlay = _ref3.forceOpenOverlay,
      id = _ref3.id,
      icon = _ref3.icon,
      key = _ref3.key,
      notShowExpandTooltip = _ref3.notShowExpandTooltip,
      overlayComponent = _ref3.overlayComponent,
      _onClick = _ref3.onClick,
      selectedAriaLabel = _ref3.selectedAriaLabel,
      title = _ref3.title,
      showButton = _ref3.showButton;
    return /*#__PURE__*/React.createElement("div", _extends({
      key: id,
      ref: function ref(_ref4) {
        return listRefs.current[id] = _ref4;
      }
    }, handleMouseMoveFreemium && {
      onMouseLeave: function onMouseLeave() {
        handleMouseMoveFreemium && handleMouseMoveFreemium();
      }
    }, {
      className: disablePointerClassName
    }), showButton ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", _extends({
      "aria-label": title,
      role: "menuitem",
      className: "aside__menu__link__anchor_new"
    }, handleMouseMove && {
      onMouseEnter: function onMouseEnter() {
        handleMouseMove(key, notShowExpandTooltip);
      }
    }, {
      onClick: function onClick() {
        _typeof(_onClick) === FUNCTION_TYPE && _onClick();
      },
      onKeyDown: function onKeyDown(e) {
        if (isEnterOrSpacePressed(e)) {
          _typeof(_onClick) === FUNCTION_TYPE && _onClick();
        }
      }
    }), /*#__PURE__*/React.createElement(LTTooltip, {
      direction: LTTooltip.Direction.RIGHT,
      text: notShowTooltipHandler(notShowExpandTooltip, key) || !collapsed ? "" : title
    }, /*#__PURE__*/React.createElement("div", {
      id: id,
      className: "aside__menu__link__anchor_new aside__menu__link",
      "aria-hidden": true
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex"
    }, icon), /*#__PURE__*/React.createElement("span", {
      className: "ltch-product-name titleMenu"
    }, title)))), notShowTooltipHandler(notShowExpandTooltip, key) ? /*#__PURE__*/React.createElement("div", {
      className: "customFreemiumHoverModal font-12",
      style: _objectSpread(_objectSpread({}, tooltipCommonStyle), {}, {
        left: collapsed ? 52 : 212,
        top: menuItemHeight * index + 34
      }),
      ref: tooltipRef
    }, /*#__PURE__*/React.createElement(FalconFreemiumComponent, {
      key: key,
      title: title
    })) : /*#__PURE__*/React.createElement(React.Fragment, null)) : /*#__PURE__*/React.createElement(ActionMenu, {
      open: openId === id || forceOpenOverlay,
      onOpenChange: function onOpenChange(val) {
        selectedIndex.current = index;
        setOpenId(val && !!overlayComponent ? id : "");
        if (val) {
          _typeof(_onClick) === FUNCTION_TYPE && _onClick();
          !overlayComponent && setShowModal(id);
        }
      }
    }, /*#__PURE__*/React.createElement(ActionMenu.Anchor, null, /*#__PURE__*/React.createElement("div", _extends({
      "aria-label": "".concat(title, " ").concat(selectedAriaLabel ? selectedAriaLabel : "") + (ariaLabelDisable ? " Disable Due to Tunnel" : ""),
      "aria-expanded": (openId === id).toString(),
      "aria-haspopup": !!overlayComponent,
      className: "aside__menu__link__anchor_new",
      role: "menuitem",
      tabIndex: tabIndex
    }, handleMouseMove && {
      onMouseEnter: function onMouseEnter() {
        handleMouseMove(key, notShowExpandTooltip);
      }
    }), /*#__PURE__*/React.createElement(LTTooltip, {
      direction: LTTooltip.Direction.RIGHT,
      text: notShowTooltipHandler(notShowExpandTooltip, key) || !collapsed ? "" : title
    }, /*#__PURE__*/React.createElement("div", {
      id: id,
      className: "aside__menu__link__anchor_new aside__menu__link",
      "aria-hidden": true
    }, " ", /*#__PURE__*/React.createElement("span", {
      className: "flex"
    }, icon), /*#__PURE__*/React.createElement("span", {
      className: "ltch-product-name titleMenu"
    }, title), !!overlayComponent && (id !== (LTInSessionSidebar === null || LTInSessionSidebar === void 0 || (_LTInSessionSidebar$c = LTInSessionSidebar.constant) === null || _LTInSessionSidebar$c === void 0 ? void 0 : _LTInSessionSidebar$c.RECORD_SESSION) || !notShowExpandTooltip) && /*#__PURE__*/React.createElement(OverlayArrowIcon, null))))), /*#__PURE__*/React.createElement(ActionMenu.Overlay, {
      visibility: true,
      align: "end",
      anchorSide: "inside-right",
      left: collapsed ? 60 : 220,
      top: overlayComponent ? getOverlayPosition(index, id) : null,
      sx: {
        borderRadius: 12,
        minWidth: "10px"
      }
    }, overlayComponent), notShowTooltipHandler(notShowExpandTooltip, key) ? /*#__PURE__*/React.createElement("div", {
      className: "customFreemiumHoverModal font-12",
      style: _objectSpread(_objectSpread({}, tooltipCommonStyle), {}, {
        left: collapsed ? 52 : 212,
        top: menuItemHeight * index + 34
      }),
      ref: tooltipRef
    }, /*#__PURE__*/React.createElement(FalconFreemiumComponent, {
      key: key,
      title: title
    })) : /*#__PURE__*/React.createElement(React.Fragment, null)));
  }), /*#__PURE__*/React.createElement("div", {
    role: "none"
  }, menuItems === null || menuItems === void 0 || (_menuItems$find2 = menuItems.find(function (_ref5) {
    var id = _ref5.id;
    return id === showModal;
  })) === null || _menuItems$find2 === void 0 ? void 0 : _menuItems$find2.modalComponent))));
};
LTInSessionSidebar.displayName = "LTInSessionSidebar";
LTInSessionSidebar.propTypes = {
  collapsed: PropTypes.bool,
  currentActiveMenuItemIndex: PropTypes.number,
  disablePointerClassName: PropTypes.string,
  extraMenuItemClassName: PropTypes.string,
  FalconFreemiumComponent: PropTypes.elementType,
  handleMouseMoveFreemium: PropTypes.func,
  handleMouseMove: PropTypes.func,
  menuItems: PropTypes.arrayOf(PropTypes.object),
  showFreemiumComponentFlag: PropTypes.bool
};
LTInSessionSidebar.constant = {
  RECORD_SESSION: "recordsession",
  DEFAULT_MENU_ITEM_HEIGHT: 36,
  SMALL_SCREEN_MENU_ITEM_HEIGHT: 34
};

export { LTInSessionSidebar as default };
